import App from './App';
import ReactDOM from 'react-dom/client';
import { APPLY_COMPANY_IDENTITY } from './_CORE/_Config/_Company/_MetaTagsIcons';
import { onApplyAppearance } from './_CORE/APP/Templates/AppTemplateResolved';

// 🔥 Titulo, description, favicons y theme-color desde _Config/_Company. Antes del render.
APPLY_COMPANY_IDENTITY();

/*
    🔥 TEMA ANTES DE PINTAR

    ⚠️ AppTemplateResolved aplica el tema dentro de un useEffect, o sea
       DESPUES del primer pintado. Con el defecto en claro no se notaba;
       con el defecto en oscuro se ve un flash blanco en cada carga.

       Aca se escribe el atributo antes del render y el flash desaparece.

    ⚠️ Se setea el atributo a mano en vez de llamar a onApplyTheme:
       onApplyTheme ademas GUARDA la preferencia, y eso convertiria un
       simple arranque en una eleccion del usuario, pisando "system".
*/
const THEME_BOOT = 'dark';
document.documentElement.setAttribute('data-theme', THEME_BOOT);
document.documentElement.setAttribute('data-bs-theme', THEME_BOOT);
document.documentElement.style.colorScheme = THEME_BOOT;

/*
    🔥 APARIENCIA ANTES DE PINTAR

    ⚠️ Los data-ls-* tambien se escribian dentro del useEffect de
       AppTemplateResolved, o sea DESPUES del primer pintado. En ese frame
       el <img> del logo no tiene altura y se dibuja a tamaño natural
       (749x345): se veia gigante y despues se acomodaba.

       Aplicandolos aca el atributo ya esta puesto en el primer render.

    ⚠️ La red de seguridad real igual esta en el CSS: _VariablesAppearance.css
       le da altura al logo sin depender de ningun atributo, asi que aunque
       el JS tarde, nunca se pinta sin tamaño.
*/
onApplyAppearance();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);